import React from "react";

import { FilterOptions as FilterOptionsContainer } from "../../../shared/GridComponents";
import { DateTimePicker, TopicsPicker, SelectInput } from "../../../shared/Forms";

const FilterOptions = () => {
	const filterOptions = [
		{
			key: "ALL",
			value: "ALL",
			label: "all",
		},
		{
			key: "SENT",
			value: "SENT",
			label: "sent",
		},
		{
			key: "PENDING",
			value: "PENDING",
			label: "pending",
		},
		{
			key: "ERROR",
			value: "ERROR",
			label: "failed to send",
		},
	];

	return (
		<FilterOptionsContainer>
			<div className="row">
				<div className="sessions col-md-8">
					<TopicsPicker field="topics" placeholder="Filter By Topic" />
				</div>
				<div className="session col-md-4">
					<SelectInput field="status" values={filterOptions} placeholder="Status" />
				</div>
			</div>
			<div className="row">
				<div className="start-time col-md-6">
					<DateTimePicker field="startDate" placeholder="Notifications From" />
				</div>
				<div className="end-time col-md-6">
					<DateTimePicker field="endDate" placeholder="Notifications To" />
				</div>
			</div>
		</FilterOptionsContainer>
	);
};

export default FilterOptions;
